export default {
  userList: { id: 'user_list' },
  createUser: { id: 'create_user' },
  editUser: { id: 'edit_user' },
  sendInvitation: { id: 'send_invitation' },
  setPassword: { id: 'set_password' },
  deleteUser: { id: 'delete_user' },
  deleteUserMessage: { id: 'delete_user_message' },
  name: { id: 'name' },
  email: { id: 'email' },
  username: { id: 'username' },
  dateUpdated: { id: 'date_updated' },
  createDate: { id: 'create_date' },
  groups: { id: 'groups' },
  roles: { id: 'roles' },
  active: { id: 'active' },
  canCreateOrDelete: { id: 'can_create_delete_jobs' },
  canReopenJobs: { id: 'can_reopen_jobs' },
  canSeeDeletedJobs: { id: 'can_see_deleted_jobs' },
  canRecoverDeletedJobs: { id: 'can_recover_deleted_jobs' },
  canSetSensorsLimits: { id: 'can_set_sensors_limits' },
  canCreateJobs: { id: 'can_create_jobs' },
  canDeleteJobs: { id: 'can_delete_jobs' },
  canDeleteJobSeries: { id: 'can_delete_job_series' },
  canManageWorkflows: { id: 'can_manage_workflows' },
}
